<template>
  <div>
    <div class="card">
      <div class="card-header py-2">
        <Spinner v-if="gsmLoading" margin_right="10px" height="20px" />
        <b-form-checkbox v-else class="display-inline marginright5" v-model="checkedAll"></b-form-checkbox>
        <span @click="checkedAll = !checkedAll">GSM<br></span>
        <Spinner v-if="gsmUkeLoading" margin_right="10px" height="20px" />
        <b-form-checkbox v-else class="display-inline marginright5" v-model="checkedAllUKE"></b-form-checkbox>
        <span @click="checkedAllUKE = !checkedAllUKE">GSM UKE</span>
      </div>
    </div>    
    <MapPlace v-for="place of $store.state.maplasPlaces[$DataOrigin.gsm]" :key="place.id" :place="place"></MapPlace>
    <MapPlace v-for="place of $store.state.maplasPlaces[$DataOrigin.gsmuke]" :key="place.id" :place="place"></MapPlace>
  </div>
</template>

<script lang="ts">
import BaseComponent from './Base.vue';
import { EventBus } from '@/ts/EventBus';
import Place from '@/ts/Place';
import PlaceType from '@/ts/PlaceType';
import { AlertStatus, DataOrigin, DownloadStatus } from '@/ts/types';
import { defineComponent } from "vue";

export default defineComponent({
    extends: BaseComponent,
    data() {
        const checkedAllUKE: boolean = false;
        const checkedAll: boolean = false;

        return {
            checkedAll,
            checkedAllUKE,
            gsmLoading: false,
            gsmUkeLoading: false
        };
    },
    created() {
      EventBus.$on('downloadExternalData', () => this.downloadPlacesGSM());
      EventBus.$on('selectedAreaChanged', (newArea: string, oldArea: string) => this.onSelectedAreaChanged(newArea, oldArea));
    },
    methods: {
      isPointInSelectedArea(lat: number | string, lon: number | string) {
        // @ts-ignore
        const areaKey = window.selectedArea;
        if (!areaKey) return true;
        // @ts-ignore
        const area = window.areas[areaKey];
        if (!area || !area[0] || !area[1]) return true;
        const minLat = Math.min(area[0][0], area[1][0]);
        const maxLat = Math.max(area[0][0], area[1][0]);
        const minLon = Math.min(area[0][1], area[1][1]);
        const maxLon = Math.max(area[0][1], area[1][1]);
        const plat = Number(lat);
        const plon = Number(lon);
        if (Number.isNaN(plat) || Number.isNaN(plon)) return false;
        return (plat >= minLat && plat <= maxLat && plon >= minLon && plon <= maxLon);
      },

      onSelectedAreaChanged(newArea: string, oldArea: string) {
        if (this.$options.places) {
          for (const place of this.$options.places) {
            try { place.getMarker().removeFrom(window.mainmap); } catch (e) {}
          }
        }
        if (this.$options.placesUke) {
          for (const place of this.$options.placesUke) {
            try { place.getMarker().removeFrom(window.mainmap); } catch (e) {}
          }
        }
        if (this.$options.placesGSMResult || this.$options.placesGSMUKEResult) {
          // reprocess using existing downloaded results
          if (this.$options.placesGSMResult) this.processPlacesGSM();
          if (this.$options.placesGSMUKEResult) this.processPlacesGSMUKE();
        }
      },
        processPlacesGSM() {
            const places: Place[] = [];
            const active = new PlaceType(1000001, 'other', {'color': 'rgb(255, 0, 255)'}, 1);
            const inactive = new PlaceType(1000001, 'other', {'color': 'rgb(255, 100, 255)'}, 1);
            for (const responsePlace of this.$options.placesGSMResult) {
              let placetype = responsePlace.is_active ? active : inactive;
              const place = new Place(responsePlace.id, responsePlace.id, '', responsePlace.latitude, responsePlace.longitude, placetype, false, null, DataOrigin.gsm, responsePlace.is_active);
              place.createMarker();
              if (this.isPointInSelectedArea(place.lat, place.lon)) {
                places.push(place);
              }
            }
            this.$options.places = places;
            this.onCheckedAllChanged();
        },
        processPlacesGSMUKE() {
            const places: Place[] = [];
            const active = new PlaceType(1000001, 'other', {'color': 'rgb(128, 0, 128)'}, 1);
            const inactive = new PlaceType(1000001, 'other', {'color': 'rgb(156, 80, 156)'}, 1);
            for (const responsePlace of this.$options.placesGSMUKEResult) {
              const placetype = responsePlace.is_active ? active : inactive;
              const place = new Place(responsePlace.id, responsePlace.id, '', responsePlace.latitude, responsePlace.longitude, placetype, false, null, DataOrigin.gsmuke, responsePlace.is_active);
              place.createMarker();
              if (this.isPointInSelectedArea(place.lat, place.lon)) {
                places.push(place);
              }
            }
            this.$options.placesUke = places;
            this.onCheckedAllUKEChanged();
        },
        downloadPlacesGSM() {
            this.gsmLoading = true;
            let endPoint = window.apiHost + 'api/stringfield/gsm/';
            this.downloadUrlWithCache(endPoint, 'gsm', 'gsm.txt', null, true).then((response) => {
              this.$options.placesGSMResult = response[1].results;
              if (response[0] == DownloadStatus.cache_fresh) {
                this.createAlert(AlertStatus.success, this.$t('placesLoaded', [response[1].results.length]).toString(), 2000);
              }
              if (response[0] == DownloadStatus.api_fresh) {
                this.createAlert(AlertStatus.success, this.$t('placesDownloaded', [response[1].results.length]).toString(), 2000);
              }
              if (response[0] == DownloadStatus.cache_last) {
                this.createAlert(AlertStatus.warning, this.$t('placesLoaded', [response[1].results.length]).toString(), 2000);
              }
            }).catch((error) => {
              this.createAlert(AlertStatus.danger, this.$t('placesError').toString(), 2000);
            }).finally(() => {
              this.gsmLoading = false;
            });
            this.gsmUkeLoading = true;
            endPoint = window.apiHost + 'api/stringfield/gsmuke/';
            this.downloadUrlWithCache(endPoint, 'gsmuke', 'gsmuke.txt', null, true).then((response) => {
              this.$options.placesGSMUKEResult = response[1].results;
              if (response[0] == DownloadStatus.cache_fresh) {
                this.createAlert(AlertStatus.success, this.$t('placesLoaded', [response[1].results.length]).toString(), 2000);
              }
              if (response[0] == DownloadStatus.api_fresh) {
                this.createAlert(AlertStatus.success, this.$t('placesDownloaded', [response[1].results.length]).toString(), 2000);
              }
              if (response[0] == DownloadStatus.cache_last) {
                this.createAlert(AlertStatus.warning, this.$t('placesLoaded', [response[1].results.length]).toString(), 2000);
              }
            }).catch((error) => {
              this.createAlert(AlertStatus.danger, this.$t('placesError').toString(), 2000);
            }).finally(() => {
              this.gsmUkeLoading = false;
            });
        },
        onCheckedAllChanged() {
            if (this.$options.places) {
              for(const place of this.$options.places) {
                if (this.checkedAll) {
                  place.getMarker().addTo(window.mainmap);
                } else {
                  place.getMarker().removeFrom(window.mainmap);
                }
              }
            } else {
              this.processPlacesGSM();
            }
        },
        onCheckedAllUKEChanged() {
            if (this.$options.placesUke) {
              for(const place of this.$options.placesUke) {
                if (this.checkedAllUKE) {
                  place.getMarker().addTo(window.mainmap);
                } else {
                  place.getMarker().removeFrom(window.mainmap);
                }
              }
            } else {
              this.processPlacesGSMUKE();
            }
        }
    },
    watch: {
        "checkedAll": [{
            handler: "onCheckedAllChanged"
        }],
        "checkedAllUKE": [{
            handler: "onCheckedAllUKEChanged"
        }]
    }
})


</script>